<template>
    <div v-if="!isLoading" class="w-full" style="height: 596px !important;">
        <div class="w-full flex justify-end mb-3">
            <ButtonComponent
                v-if="dataArr.length !== 0"
                type="primary-btn"
                label="+ Create New Template"
                @click="onValidate()"
            />
        </div>
        <div v-if="dataArr.length !== 0" class="w-full">
            <table>
                <thead class="items-center table-header">
                    <tr>
                        <th class="spacing-tab borderRight">Name</th>
                        <th class="spacing-tab borderRight w-2/6">Description</th>
                        <th class="spacing-tab borderRight">Creator</th>
                        <th class="spacing-tab">Last Modified</th>
                    </tr>
                </thead>
                <tbody class="items-center table-body">
                    <tr
                        v-for="(value, index) in dataArr" :key="index"
                        class="hover:bg-gray-100 transition duration-150 ease-in-out"
                    >
                        <td class="spacing-tab borderRight cursor-pointer" @click="onClickGetData(value.uuid)">{{ value.template_name }}</td>
                        <td class="spacing-tab borderRight cursor-pointer" @click="onClickGetData(value.uuid)">{{ value.description }}</td>
                        <td class="spacing-tab borderRight cursor-pointer" @click="onClickGetData(value.uuid)">{{ value.name }}</td>
                        <td class="spacing-tab">
                            <span class="relative" style="top: 12px !important">{{ value.date }}</span>

                            <Menu as="div" class="ml-3">
                                <div>
                                    <MenuButton class="relative" style="left: 95% !important">
                                        <span class="sr-only">Open Action</span>
                                        <DotsVerticalIcon
                                            class="cursor-pointer h-5 -top-1 relative"
                                        />
                                    </MenuButton>
                                </div>
                                <transition
                                    enter-active-class="transition ease-out duration-100"
                                    enter-from-class="transform opacity-0 scale-95"
                                    enter-to-class="transform opacity-100 scale-100"
                                    leave-active-class="transition ease-in duration-75"
                                    leave-from-class="transform opacity-100 scale-100"
                                    leave-to-class="transform opacity-0 scale-95"
                                >
                                    <MenuItems class="mItems">
                                        <MenuItem
                                            v-for="item in ReportAction"
                                            :key="item.name"
                                            v-slot="{ active }"
                                            class="absolute"
                                        >
                                            <a
                                                :class="[
                                                    active ? 'bg-gray-100' : '',
                                                    'block px-4 py-2 text-sm text-gray-700 cursor-pointer',
                                                ]"
                                                class="relative"
                                                @click="onShowModal(item.type,value.uuid)"
                                            >
                                                {{ item.name }}
                                            </a>
                                        </MenuItem>
                                    </MenuItems>
                                </transition>
                            </Menu>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="py-3">
                <PaginationComponent
                    v-if="totalPage > 1"
                    v-model="currentPage"
                    class="w-full mt-2"
                    :total-page="totalPage"
                    @page-clicked="paginationChanged($event)"
                />
            </div>
        </div>
        <div v-else>
            <div class="relative flex flex-col justify-center overflow-hidden top-48">
                <PresentationChartLineIcon class="h-10 m-auto text-gray-400" />
                <p class="text-gray-600 mb-4 text-center">No report available. Let's make one</p>
                <ButtonComponent
                    type="primary-btn"
                    block
                    label="+ Create New Report"
                    class="w-44 m-auto"
                    @click="onValidate()"
                />
            </div>
        </div>
    </div>
    <div v-else class="h-96 flex items-center justify-center">
        <SpinnerComponent color="primary" size="64" />
    </div>
    <SlotModalComponent
        v-model="showModal"
        container-class="notice-modal"
        :scrollable="false"
        :is-semi-transparent="true"
    >
        <template v-slot:body>
            <div class="body-wrapper">
                <span>Are you sure you want to delete this template ?</span>
            </div>
        </template>
        <template v-slot:footer="{ onCancel }">
            <div class="footer-wrapper">
                <ButtonComponent
                    type="button"
                    label="No"
                    class="buttonFilter"
                    style="width: 48% !important; display: inline-block !important;"
                    @click="onCancel"
                />
                <ButtonComponent
                    label="Yes"
                    class="ml-2 justify-center"
                    style="width: 48% !important;"
                    @click="onNavigateMenu(selectedType, selectedId)"
                />
            </div>
        </template>
    </SlotModalComponent>
    <DialogBoxComponent
        :status="isOpenDialog"
        :message="dialogMessage"
        :reload="true"
    />
</template>
<script>
import { onMounted, ref } from "vue";
import { PresentationChartLineIcon, DotsVerticalIcon } from "@heroicons/vue/outline";
import useReport from "@Functions/useReport.js";
import { PaginationComponent } from "@CommonComponents";
import {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
} from "@headlessui/vue";
import { ReportAction } from "@Utilities/enum";
import { SlotModalComponent } from "@CommonComponents";

export default {
    name: "TableCompo",
    components: {
        PresentationChartLineIcon,
        DotsVerticalIcon,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        SlotModalComponent,
        PaginationComponent
    },
    setup() {
        const showModal = ref(false);
        const redirectPath = ref();
        const currentPath = window.location;
        const onValidate = () => {
            redirectPath.value = currentPath.pathname.replace('list', 'add');
            window.location = redirectPath.value;
        };
        const { getReportList, deleteTemplate } = useReport();
        const dataArr = ref([]);
        const isLoading = ref(true);
        const isOpenDialog = ref(false);
        const dialogMessage = ref();
        const selectedType = ref();
        const selectedId = ref();
        const currentPage = ref(1);
        const totalPage = ref(0);

        onMounted(() => {
            getReportList( { page: 1 }).then((resp) => {
                console.log(resp)
                dataArr.value = resp.data.data
                currentPage.value = resp.data.current_page
                totalPage.value = resp.data.last_page
                isLoading.value = false
            })
        });

        const onShowModal = (type, id) => {

            switch (type) {
            case 'delete':
                showModal.value = true;
                break;
            default:
                window.location = currentPath.origin + "/template/report/update/" + id
                break;
            }

            selectedType.value = type;
            selectedId.value = id;
        }

        const onClickGetData = (uuid) => {
            let uri = window.location.origin+"/generate/template/"+ uuid;
            window.location = uri;
        }

        const onNavigateMenu = (type, id) => {
            switch (type) {
            case 'edit':
                window.location = currentPath.origin + "/template/report/update/" + id
                break;
            case 'delete':
                showModal.value = false;
                deleteTemplate(id).then(() => {
                    isOpenDialog.value = true
                    dialogMessage.value = "Successfully Deleted";
                })
                break;
            default:
                break;
            }
        }

        const paginationChanged = (page) => {
            console.log(page)
            isLoading.value = true
            getReportList({ page }).then((resp) => {
                dataArr.value = resp.data.data
                currentPage.value = resp.data.current_page
                isLoading.value = false
            })
        }

        return {
            onValidate,
            dataArr,
            isLoading,
            ReportAction,
            isOpenDialog,
            dialogMessage,
            onClickGetData,
            onNavigateMenu,
            showModal,
            onShowModal,
            selectedType,
            selectedId,
            currentPage,
            totalPage,
            paginationChanged
        };
    },
};
</script>
<style lang="scss">
.initial-landing {
    @apply border border-gray-200 rounded-lg shadow-sm divide-gray-200 bg-white;
    /* .initial-landing {
        &__icon {
            @apply text-gray-400 relative top-4;
        }
    } */
}
.spacing-tab{
    @apply py-2 px-4 font-normal pb-2 pt-2 text-sm;
}
.mItems{
    @apply origin-top-right absolute right-4 -mt-6 w-48 z-10 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none;
}
        table {
            @apply min-w-full shadow rounded-md bg-white border border-gray-200;
            tr {
                @apply divide-x;
                th,
                td {
                    @apply whitespace-nowrap p-2 font-normal text-xs text-gray-500;
                    min-width: 124px;
                }
            }
            .table-header {
                tr {
                    @apply divide-gray-200 bg-gray-100;
                    th {
                        @apply uppercase border-b border-gray-200 font-medium; // here
                    }
                    &:last-child {
                        @apply bg-gray-50;
                    }
                }
            }
            .table-body {
                @apply divide-y divide-gray-200 border-b border-gray-200;
                tr {
                    @apply divide-gray-200;
                    th {
                        @apply text-left;
                    }
                    &.highlighted {
                        th,
                        td {
                            @apply font-semibold;
                        }
                    }
                    &:nth-child(even) {
                        @apply bg-gray-50;
                    }

                    .indented {
                        @apply pl-10;
                    }
                }
                .item-dcrepncy {
                    @apply bg-red-300 #{!important};
                }
            }
        }
        .empty-state-component {
            @apply h-full py-20;
        }

</style>
<style lang="css">
.borderRight {
    border-right-width: 1px !important;
}
</style>
